const errors = {
  infos: [],
  contact: [],
  importRule: [],
  taxLimit: [],
  docs: [],
  funds: []
}

export default {
  list: [],
  errors: { ...errors },
  initialErrors: { ...errors },
  payerGroup: {
    limits: []
  }
}



// WEBPACK FOOTER //
// ./src/features/clients/store/payer_groups/state.js